import { Injectable } from '@angular/core';

@Injectable()
export class BrowserUtils {
  isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
}